// 20260908-google-attribution-v1. Google evidence is independent of Meta consent policy.
(() => {
  if (window.MaostixGoogleAttribution) return;
  const KEY = '_maostix_google_click_v1';
  const TTL = 30 * 24 * 60 * 60;
  const IDS = ['gclid', 'gbraid', 'wbraid'];
  const UTMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id'];
  let click = null, lastConsent = null, lastSignals = '', timer = 0, loadRequested = false;
  let syncRunning = false, syncAgain = false, lastSynced = '';
  let candidate = fromParams(new URLSearchParams(location.search));
  let hadGoogleContext = !!candidate || document.cookie.split(';').some(part => part.trim().startsWith(KEY + '='));
  function validTime(value) { const t = Date.parse(value); return Number.isFinite(t) && t <= Date.now() + 60000 && Date.now() - t < TTL * 1000; }
  function fromParams(params) {
    const out = {v: 1, click_at: new Date().toISOString()};
    for (const key of IDS) { const s = params.get(key) || ''; if (/^[A-Za-z0-9._~-]{1,512}$/.test(s)) out[key] = s; }
    if (!IDS.some(key => out[key])) return null;
    // Preserve original click time only on our explicit storefront bridge, never extend it on every page.
    const transferred = params.get('msx_google_click_at');
    if (params.has('msx_google_click_at')) { if (!transferred || !validTime(transferred)) return null; out.click_at = new Date(transferred).toISOString(); }
    for (const key of UTMS) { const s = params.get(key); if (s) out[key] = s.slice(0, 160); }
    return out;
  }
  function decision(v) { return v === 'yes' ? 'yes' : v === 'no' ? 'no' : 'unknown'; }
  function readConsent() {
    const api = window.Shopify && window.Shopify.customerPrivacy;
    let raw = {};
    try { if (api && typeof api.currentVisitorConsent === 'function') raw = api.currentVisitorConsent() || {}; } catch (_) {}
    function allowed(name) { try { return api && typeof api[name] === 'function' ? api[name]() === true : null; } catch (_) { return null; } }
    const marketing = decision(raw.marketing), sale = decision(raw.sale_of_data);
    const ma = allowed('marketingAllowed'), sa = allowed('saleOfDataAllowed');
    const gpc = navigator.globalPrivacyControl === true;
    const deny = gpc || marketing === 'no' || sale === 'no' || (marketing === 'yes' && (ma === false || sa === false));
    const grant = !deny && marketing === 'yes' && ma === true && sa === true;
    const signals = {marketing_decision: marketing, marketing_allowed: ma, sale_of_data_decision: sale, sale_of_data_allowed: sa,
      ad_user_data: deny ? 'DENIED' : grant ? 'GRANTED' : 'UNKNOWN', ad_personalization: 'DENIED', gpc: gpc,
      source: 'shopify_customer_privacy'};
    const signature = JSON.stringify(signals);
    if (signature !== lastSignals) { lastSignals = signature; lastConsent = {...signals, observed_at: new Date().toISOString()}; }
    return lastConsent;
  }
  function cookieDomain() { return /(^|\.)maostix\.com$/i.test(location.hostname) ? '; Domain=maostix.com' : ''; }
  function erase() {
    document.cookie = KEY + '=; Path=/; Max-Age=0; SameSite=Lax; Secure' + cookieDomain();
    document.cookie = KEY + '=; Path=/; Max-Age=0; SameSite=Lax; Secure';
    // Clean only our namespace; never edit Shopify privacy cookies or existing Meta state.
    try { localStorage.removeItem(KEY); } catch (_) {}
    for (const key of IDS) { document.cookie = '_maostix_ab_' + key + '=; Path=/; Max-Age=0; SameSite=Lax; Secure'; document.cookie = '_maostix_ab_' + key + '=; Path=/; Max-Age=0; SameSite=Lax; Secure' + cookieDomain(); }
    click = null; candidate = null;
  }
  function readClick() {
    try {
      const prefix = KEY + '=', part = document.cookie.split(';').map(x => x.trim()).find(x => x.startsWith(prefix));
      const data = part ? JSON.parse(decodeURIComponent(part.slice(prefix.length))) : null;
      if (!data || data.v !== 1 || !validTime(data.click_at) || !IDS.some(k => /^[A-Za-z0-9._~-]{1,512}$/.test(data[k] || ''))) return null;
      const out = {v:1, click_at: data.click_at};
      for (const k of IDS) if (/^[A-Za-z0-9._~-]{1,512}$/.test(data[k] || '')) out[k] = data[k];
      for (const k of UTMS) if (typeof data[k] === 'string') out[k] = data[k].slice(0,160);
      return out;
    } catch (_) { return null; }
  }
  function persist(data) {
    const age = Math.max(0, Math.floor((Date.parse(data.click_at) + TTL * 1000 - Date.now()) / 1000));
    const copy = {...data}; let value = encodeURIComponent(JSON.stringify(copy));
    if (value.length > 3500) { for (const k of UTMS) delete copy[k]; value = encodeURIComponent(JSON.stringify(copy)); }
    if (value.length <= 3500 && age > 0) document.cookie = KEY + '=' + value + '; Path=/; Max-Age=' + age + '; SameSite=Lax; Secure' + cookieDomain();
  }
  function snapshot() {
    const consent = readConsent();
    if (consent.ad_user_data === 'DENIED') erase();
    else if (consent.ad_user_data === 'GRANTED') {
      if (!click) click = readClick();
      if (candidate) {
        const same = click && IDS.every(k => (click[k] || '') === (candidate[k] || ''));
        if (!same) click = candidate;
        candidate = null; persist(click);
      }
      if (click && !validTime(click.click_at)) click = null;
      if (click) hadGoogleContext = true;
    }
    const out = {v:1};
    if (consent.ad_user_data === 'GRANTED' && click) { for (const k of IDS) if (click[k]) out[k] = click[k]; out.click_at = click.click_at; }
    out.consent = consent;
    return out;
  }
  function fields() { return {__msx_google: JSON.stringify(snapshot())}; }
  function utmAttributes() {
    const s = snapshot(), out = {};
    // Empty identifiers actively clear a previous eligible click after denial or unknown destination consent.
    for (const k of IDS) out[k] = s[k] || '';
    if (s.consent.ad_user_data === 'GRANTED' && click) for (const k of UTMS) if (click[k]) out[k] = click[k];
    return out;
  }
  function decorateParams(params) {
    const s = snapshot();
    for (const k of IDS) { params.delete(k); if (s[k]) params.set(k, s[k]); }
    params.delete('msx_google_click_at');
    if (s.click_at) params.set('msx_google_click_at', s.click_at);
    if (s.consent.ad_user_data === 'GRANTED' && click) for (const k of UTMS) if (click[k] && !params.has(k)) params.set(k, click[k]);
    return params;
  }
  async function sync() {
    const signature = JSON.stringify(snapshot());
    if (!hadGoogleContext) return;
    if (lastSynced === signature) return;
    if (syncRunning) { syncAgain = true; return; }
    const cart = window.MaostixCart;
    if (!cart || typeof cart.syncGoogleAttribution !== 'function') return;
    syncRunning = true;
    try { const result = await cart.syncGoogleAttribution(); if (result && JSON.stringify(snapshot()) === signature) lastSynced = signature; }
    catch (_) { /* No checkout or payment is triggered by tracking. */ }
    finally { syncRunning = false; if (syncAgain) { syncAgain = false; schedule(); } }
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(sync, 100); }
  function loadPrivacy() {
    const shop = window.Shopify;
    if (shop && shop.customerPrivacy) return;
    if (!loadRequested && shop && typeof shop.loadFeatures === 'function') {
      loadRequested = true;
      shop.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], function(error) { if (!error) schedule(); });
    }
  }
  window.MaostixGoogleAttribution = {revision:'20260908-google-attribution-v1', snapshot:snapshot, cartAttributes:fields, lineProperties:fields, utmAttributes:utmAttributes, decorateParams:decorateParams, refresh:schedule};
  document.addEventListener('visitorConsentCollected', schedule);
  window.addEventListener('pageshow', function(){loadPrivacy();schedule();});
  loadPrivacy(); snapshot(); schedule();
  // Bounded startup checks cover asynchronously loaded Shopify privacy API and drawer initialization.
  for (const delay of [500,1500,3000]) setTimeout(function(){loadPrivacy();schedule();}, delay);
})();

(() => {
  if (window.__maostixTruthAttributionLoaded) return;
  window.__maostixTruthAttributionLoaded = true;

  const VISITOR_KEY = "maostix_truth_visitor_v1";
  const SESSION_KEY = "maostix_truth_session_v1";
  const TOUCH_KEY = "maostix_truth_touch_v1";
  const SYNC_KEY = "maostix_truth_cart_sync_v1";
  const TRACKING_KEYS = [
    "utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term",
    "fbclid", "ttclid",
  ];
  let syncTimer = 0;
  let syncing = false;

  function id(prefix) {
    if (window.crypto?.randomUUID) return `${prefix}_${window.crypto.randomUUID()}`;
    return `${prefix}_${Date.now().toString(36)}_${Math.random().toString(36).slice(2)}`;
  }

  function storageId(storage, key, prefix, seeds = []) {
    try {
      const existing = storage.getItem(key);
      if (existing) return existing;
      const seed = seeds.find(Boolean);
      const created = String(seed || "").trim().slice(0, 180) || id(prefix);
      storage.setItem(key, created);
      return created;
    } catch (_error) {
      return null;
    }
  }

  function cookie(name) {
    const prefix = `${name}=`;
    for (const part of document.cookie.split(";")) {
      const value = part.trim();
      if (value.startsWith(prefix)) return decodeURIComponent(value.slice(prefix.length));
    }
    return null;
  }

  function privacy() {
    const api = window.Shopify?.customerPrivacy;
    const permission = (method) => {
      if (typeof api?.[method] !== "function") return {allowed: false, observed: false};
      try {
        return {allowed: Boolean(api[method]()), observed: true};
      } catch (_error) {
        return {allowed: false, observed: false};
      }
    };
    const decision = (value) => value === "yes" ? "yes" : value === "no" ? "no" : "unknown";
    let visitorConsent = {};
    try {
      visitorConsent = typeof api?.currentVisitorConsent === "function"
        ? (api.currentVisitorConsent() || {})
        : {};
    } catch (_error) {}
    const analytics = permission("analyticsProcessingAllowed");
    const marketing = permission("marketingAllowed");
    const sale = permission("saleOfDataAllowed");
    const marketingDecision = decision(visitorConsent.marketing);
    const saleDecision = decision(visitorConsent.sale_of_data);
    return {
      analytics: analytics.allowed,
      marketing: marketing.allowed,
      sale: sale.allowed,
      marketingObserved: marketingDecision !== "unknown",
      saleObserved: saleDecision !== "unknown",
      marketingEffectiveObserved: marketing.observed,
      saleEffectiveObserved: sale.observed,
      marketingDecision,
      saleDecision,
    };
  }

  function currentTouch(analyticsAllowed) {
    if (!analyticsAllowed) return {};
    let stored = {};
    try { stored = JSON.parse(localStorage.getItem(TOUCH_KEY) || "{}") || {}; } catch (_error) {}
    if (!stored.first_touch && !stored.last_touch && typeof stored === "object" && Object.keys(stored).length) {
      stored = {first_touch: stored, last_touch: stored};
    }
    for (const touch of [stored, stored.first_touch, stored.last_touch]) if (touch && typeof touch === 'object') for (const k of ['gclid','gbraid','wbraid']) delete touch[k];
    try { localStorage.setItem(TOUCH_KEY, JSON.stringify(stored)); } catch (_) {}
    const params = new URLSearchParams(location.search);
    const current = {};
    for (const key of TRACKING_KEYS) {
      const value = params.get(key);
      if (value) current[key] = value.slice(0, 300);
    }
    if (Object.keys(current).length) {
      const touch = {...current, captured_at: new Date().toISOString()};
      stored = {first_touch: stored.first_touch || touch, last_touch: touch};
      try { localStorage.setItem(TOUCH_KEY, JSON.stringify(stored)); } catch (_error) {}
    }
    return stored;
  }

  function fbcFromClick(touch, marketingAllowed) {
    if (!marketingAllowed) return null;
    const existing = cookie("_fbc");
    if (existing) return existing;
    const fbclid = touch?.last_touch?.fbclid || touch?.first_touch?.fbclid || touch?.fbclid;
    if (!fbclid) return null;
    const value = `fb.1.${Date.now()}.${fbclid}`;
    document.cookie = `_fbc=${encodeURIComponent(value)}; Path=/; Max-Age=7776000; SameSite=Lax; Secure`;
    return value;
  }

  // 20260907-attribution-cart-queue-v1: share the custom cart mutation queue when present.
  function serializeCartAttribution(fn) {
    var cart = window.MaostixCart;
    return cart && typeof cart.serializeMutation === 'function' ? cart.serializeMutation(fn) : fn();
  }

  async function syncCart() {
    if (syncing) return;
    syncing = true;
    try {
      const allowed = privacy();
      const root = window.Shopify?.routes?.root || "/";
      const cartResponse = await fetch(`${root}cart.js`, {
        credentials: "same-origin",
        headers: {Accept: "application/json", "X-Maostix-Truth": "1"},
      });
      if (!cartResponse.ok) return;
      const cart = await cartResponse.json();
      if (!cart?.token || !cart?.item_count) return;
      const touch = currentTouch(allowed.analytics);
      const params = new URLSearchParams(location.search);
      const attributes = {
        __msx_consent: JSON.stringify({
          analytics: allowed.analytics,
          marketing: allowed.marketing,
          sale_of_data: allowed.sale,
          marketing_observed: allowed.marketingObserved,
          sale_of_data_observed: allowed.saleObserved,
          marketing_effective_observed: allowed.marketingEffectiveObserved,
          sale_of_data_effective_observed: allowed.saleEffectiveObserved,
          marketing_decision: allowed.marketingDecision,
          sale_of_data_decision: allowed.saleDecision,
          marketing_source: allowed.marketingObserved || allowed.marketingEffectiveObserved
            ? "shopify_theme_customer_privacy"
            : "not_observed",
          sale_of_data_source: allowed.saleObserved || allowed.saleEffectiveObserved
            ? "shopify_theme_customer_privacy"
            : "not_observed",
        }),
      };
      if (allowed.analytics) {
        attributes.__msx_vid = storageId(localStorage, VISITOR_KEY, "v", [
          params.get("maostix_ab_vid"), params.get("mvid"),
          cookie("_maostix_ab_v5_vid"), cookie("_maostix_ab_vid"),
        ]);
        attributes.__msx_sid = storageId(sessionStorage, SESSION_KEY, "s", [
          params.get("maostix_ab_sid"), params.get("msid"),
          cookie("_maostix_ab_v5_sid"), cookie("_maostix_ab_sid"),
        ]);
        attributes.__msx_touch = JSON.stringify(touch).slice(0, 1800);
      }
      if (allowed.marketing) {
        attributes.__msx_fbp = cookie("_fbp") || "";
        attributes.__msx_fbc = fbcFromClick(touch, true) || "";
      }
      if (window.MaostixGoogleAttribution) Object.assign(attributes, window.MaostixGoogleAttribution.cartAttributes(), window.MaostixGoogleAttribution.utmAttributes());
      const signature = `${cart.token}:${JSON.stringify(attributes)}`;
      try { if (sessionStorage.getItem(SYNC_KEY) === signature) return; } catch (_error) {}
      const updateResponse = await serializeCartAttribution(function() { if(window.MaostixGoogleAttribution)Object.assign(attributes,MaostixGoogleAttribution.cartAttributes(),MaostixGoogleAttribution.utmAttributes());return fetch(`${root}cart/update.js`, {
        method: "POST",
        credentials: "same-origin",
        headers: {"Content-Type": "application/json", Accept: "application/json", "X-Maostix-Truth": "1"},
        body: JSON.stringify({attributes}),
      }); });
      if (!updateResponse.ok) return;
      try { sessionStorage.setItem(SYNC_KEY, `${cart.token}:${JSON.stringify(attributes)}`); } catch (_error) {}
    } catch (_error) {
      // Attribution must never affect add-to-cart or checkout.
    } finally {
      syncing = false;
    }
  }

  function scheduleSync(delay = 250) {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(syncCart, delay);
  }

  currentTouch(privacy().analytics);
  const originalFetch = window.fetch.bind(window);
  window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    try {
      const target = String(typeof args[0] === "string" ? args[0] : args[0]?.url || "");
      const headers = args[1]?.headers || {};
      const ownRequest = headers["X-Maostix-Truth"] || headers.get?.("X-Maostix-Truth");
      if (!ownRequest && /\/cart\/(add|change|update)(\.js)?(?:\?|$)/.test(target)) scheduleSync(200);
    } catch (_error) {}
    return response;
  };

  document.addEventListener("submit", (event) => {
    if (event.target?.matches?.('form[action*="/cart/add"]')) scheduleSync(350);
  }, true);
  document.addEventListener("visitorConsentCollected", () => scheduleSync(0));
  window.addEventListener("pageshow", () => scheduleSync(0), {once: true});
})();
